import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing8 } from 'approot/shared/styles/spacing.style';

export const ContentCardTags = styled.div`
  & > div {
    margin-right: ${rem(spacing8)};
    margin-top: ${rem(spacing8)};
    z-index: 2;
  }
`;
